import { AnswerResultEnum, CompletionResultStatusEnum } from '@/swagger/constants/quiz-enums';

export const en = {
  quiz: {
    startDialog: {
      start: 'Start the quiz',
      resume: 'Resume the quiz',
      restart: 'Restart the quiz',
      questions: '{{questions}} Questions',
      duration: '{{time}} min',
      credits: '{{credits}} Credits',
      title: 'Quiz: {{quizName}}',
      colleaguesHint: {
        singular: 'Another one of your colleagues has already taken the quiz, don’t fall behind!',
        plural: 'Over {{colleagues}} colleagues have already taken the quiz, don’t fall behind!',
      },
      errors: {
        noCredits: 'You do not have enough credits to start the quiz.',
      },
    },
    confirmExitFromQuizDialog: {
      title: 'Exit the content',
      description:
        'By exiting the quiz, you will have the opportunity to complete it later without losing your progress.',
      adminDescription:
        "If you close the quiz now, you won't be able to resume from where you left off, but you can restart it from the beginning as many times as you want.",
      confirm: 'Exit',
      cancel: 'Cancel',
    },
    confirmRestartQuizDialog: {
      title: 'Ready for another attempt?',
      description: 'The quiz helps you improve: the new attempt requires {{credits}} credits.',
      confirm: 'Retake quiz',
      cancel: 'Cancel',
    },
    dynamicQuiz: {
      exit: 'Exit the quiz',
      quizTitle: 'Quiz:\n{{quizName}}',
      stepXonY: 'Step {currentStep} of {totalSteps}',
      answerFeedbackLabels: {
        [AnswerResultEnum.CORRECT]: 'Correct answer!',
        [AnswerResultEnum.INCORRECT]: 'Incorrect answer.',
        [AnswerResultEnum.PARTIALLY]: 'Partially correct answer.',
      },
      quizResult: {
        [CompletionResultStatusEnum.FULL_SUCCEEDED]: {
          title: 'Great Result!',
          label: 'You and {{total}} colleagues exceeded the average score of {{score}}%!',
          description:
            'Do you want to improve even more? Take the quiz again: each new attempt will give you different questions to strengthen your skills.',
        },
        [CompletionResultStatusEnum.PARTIALLY_SUCCEEDED]: {
          title: 'Well done!',
          label:
            'You are in line with most of your colleagues who achieved an average score of {{score}}%',
          description:
            'Do you want to improve even more? Take the quiz again: each new attempt will give you different questions to strengthen your skills.',
        },
        [CompletionResultStatusEnum.NOT_SUCCEEDED]: {
          title: 'Perfect time to improve!',
          label:
            'Your result is below the average of your colleagues: a great opportunity to improve!',
          description:
            'Do you want to improve even more? Take the quiz again: each new attempt will give you different questions to strengthen your skills.',
        },
        [CompletionResultStatusEnum.SUCCEEDED]: {
          title: 'Quiz completed!',
          label: '',
          description:
            "The result shows your current level. It's a great starting point to reinforce what you already know and identify any areas for improvement.",
        },
        completedQuiz: 'You completed the quiz',
        correctAnswers: '{{correct}} out of {{total}} correct answers',
        cta: {
          next: 'Close',
          restart: 'Retake the quiz',
        },
      },
    },
  },
};
